import { render, staticRenderFns } from "./greetingDetail.vue?vue&type=template&id=051660ba&scoped=true&"
import script from "./greetingDetail.vue?vue&type=script&lang=js&"
export * from "./greetingDetail.vue?vue&type=script&lang=js&"
import style0 from "./greetingDetail.vue?vue&type=style&index=0&id=051660ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051660ba",
  null
  
)

component.options.__file = "greetingDetail.vue"
export default component.exports